import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=414c1e1a&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c1e1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
